export const VERTICAL_GRID_GAP_PERCENTAGE = 0.01;
export const HORIZONTAL_GRID_GAP_PERCENTAGE = 0.025;

export const LAYOUT_MAP: Record<number, number[]> = {
  1: [2],
  2: [2],
  3: [3],
  4: [2, 2],
  5: [3, 2],
  6: [3, 3],
  7: [4, 3],
  8: [4, 4],
  9: [3, 3, 3],
  10: [3, 4, 3],
  11: [4, 3, 4],
  12: [4, 4, 4],
};
